<load-spinner [show]="showSpinner"></load-spinner>

<div>
  <input
    type="file" #template_file_upload
    style="display:none"
    (change)="onTemplateFileUploadChanged()"
    name="inputTemplateFileUpload" />
</div>



<div class="bulk-upload-events row">
  <div class="mb-2 col-8">
    <ul class="nav mb-3" id="links" role="link" >
      <li class="nav-item">
        <a class="nav-link" [routerLink]="" (click)="slideOutForm.show(); selectedRow=null"><i class="fa fa-plus-circle"></i> Add Manual Usage </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [routerLink]="" (click)="onTemplateUploadClick()"><i class="fa fa-arrow-up"></i> Bulk Usage </a>
      </li>
      <li class="nav-item">
          <a class="nav-link" [routerLink]="" (click)="onTemplateDownloadClick()"><i class="fa fa-arrow-down"></i> Usage Template </a>
      </li>
    </ul>
  </div>
  <div class="col-4">
    <ul class="list-group">
      <li (click)="showBulkStatus = !showBulkStatus" class="list-group-item list-group-item h6 d-flex justify-content-between align-items-center">
        <span>Bulk Usage Upload States &nbsp;
        <span class="badge badge-primary badge-pill">{{bulkStates.length}}</span></span>
        <i class="fas" [ngClass]="{'fa-angle-down': !showBulkStatus, 'fa-angle-up': showBulkStatus}"></i>
      </li>
      <div class="listItems container-list" *ngIf=showBulkStatus [ngClass]="{'disabled': bulkStateDeleteActive}">
        <ng-template ngFor let-state [ngForOf]="bulkStates">
          <li class="list-group-item list-group-item-success d-flex justify-content-between align-items-center" *ngIf="!getState(state).isError && getState(state).isFinished">
            <span [class.bulkUploadFailureMessage] = "state.errors"> {{ state.fileName }} - Finished! - Stopped at: {{ state.endDateTime }} - {{ state.errors }} </span>
                <i (click)="deleteState(state)" class="far fa-times-circle"></i>
            </li>
            <li class="list-group-item list-group-item-primary d-flex justify-content-between align-items-center" *ngIf="!getState(state).isError && !getState(state).isFinished">
                {{ state.fileName }} - Running - Started at: {{ state.startDateTime }}
                <i style="display: none;" (click)="deleteState(state)" class="far fa-times-circle"></i>
            </li>
            <li class="list-group-item list-group-item-danger d-flex justify-content-between align-items-center" *ngIf="getState(state).isError">
                {{ state.fileName }} - Errored - {{ state.errors }}
                <i (click)="deleteState(state)" class="far fa-times-circle"></i>
            </li>
        </ng-template>
      </div>
    </ul>
  </div>
</div>

<div id="container" class="container-fluid">
  <ul class="nav nav-tabs mb-3" id="tabs" role="tablist" >
    <li class="nav-item">
      <a class="nav-link active"
      id="current-tab"
      data-toggle="tab"
      href="#"
      role="tab"
      (click)="onTabClick($event)">
      Period: {{(currentPeriod.getMonth()+1) + '/' + currentPeriod.getFullYear()}}</a>
    </li>

    <li class="nav-item">
      <a class="nav-link"
      id="next-tab"
      data-toggle="tab"
      href="#"
      role="tab"
      (click)="onTabClick($event)">
      Period: {{(nextPeriod.getMonth()+1) + '/' + nextPeriod.getFullYear()}}</a>
    </li>
  </ul>

  <div class="filters" [ngClass]="{hide: hideShow}">
    <div class="hide-show hide-show-container">
      <button *ngIf="!hideShow" class="btn btn-secondary btn-sm" (click)="hideShow = !hideShow; onDataTableFiltersClick();">Hide & Apply</button>
      <button *ngIf="hideShow"  class="btn btn-secondary btn-sm" (click)="hideShow = !hideShow;">Show Filters</button>
    </div>
    <div *ngIf="hideShow" class="hide-show current-filters">
      <!-- foreach filter -->
      <span *ngIf="filter_clientId">
        <b>Client ID: </b> {{filter_clientId}}
      </span>
    </div>
    <div class="filters-area">
      <div class="form-group">
          <label class="font-weight-bold" for="clientIdSelect">Client ID * </label>
          <ng-select
            [disabled]="showSpinner ? '' : null"
            [virtualScroll]="true"
            [items]="_sharedDataService.allClientParties"
            bindLabel="partyName"
            bindValue="clientParty.mailStop"
            [searchFn]="matchClientPartyRow"
            [(ngModel)]="filter_clientId">
            <ng-template ng-option-tmp let-item="item">
                {{item.clientParty.mailStop}} -- {{item.partyName}}
            </ng-template>
        </ng-select>
      </div>
      <div class="clearfix">
        <button (click)="onDataTableFiltersClick()" class="btn btn-primary float-right">Apply</button>
      </div>
    </div>
  </div>

  <ngx-datatable
    id=#mueGrid
    name="Manual Usage Events"
    class="material striped"
    style="height: calc(100vh - 330px)"
    [columns]="columns"
    [columnMode]="'force'"
    [headerHeight]="50"
    [footerHeight]="40"
    [rowHeight]="rowHeight"
    [count]="rows ? rows.length : 0"
    [rows]="rows"
    [loadingIndicator]="isGridLoading"
    [scrollbarV]="true"
    [virtualization]="true"
    [selectionType]="'single'"
    [selected]="selected"
    (activate)="onRowSelect($event)">
  </ngx-datatable>

  <ng-template #deleteTpl let-value="value">
      <button md-icon-button (click)="onRemoveRow(value)">
        <i class="fa fa-ban"></i>
      </button>
  </ng-template>
</div>

<slide-out id="slideoutform"
  (onClose)="onClose($event)"
>
  <div class="header">
    <span *ngIf="selectedRow">
      Avi Client Id: {{selectedRow.aviClientId}}
    </span>
    <span *ngIf="!selectedRow">
      New Manual Usage
    </span>
  </div>
  <div class="form-body">
    <ltb-manual-form
      [existingManualEvent]="selectedRow">
    </ltb-manual-form>
  </div>
  <div class="footer">
      <button>Submit</button>
  </div>
</slide-out>
